import Vuex from 'vuex'
import Vue from 'vue'
import createPersistedState from 'vuex-persistedstate'

import classModule from './learning/class'
import classDetail from './learning/classDetail'
import category from './other/category'
import email from './notify/email'
/**
 * SALE
 */
import contact from './contact/contact'
import product from './contact/product'
import bill from './bill/bill'
import billDetail from './bill/billDetail'
import leads from '@/store/lead/leads.js'
import lead from '@/store/lead/lead.js'
/**
 * CLASS
 */
import lesson from './course/lesson'
import resource from './course/resource'
import course from './course/course'
import marksheet from './report/marksheet'
import accountsheet from './report/accountsheet'
import major from './course/major'
import majorDetail from './course/majorDetail'
import generation from './course/generation'
import slot from './learning/slot'

import log from './other/log'
import event from './learning/event'
import attendance from './learning/attendance'
import mark from './learning/mark'
import stats from './other/stats'

/**
 * FACILITY & LIBRARY
 */
import facility from './facility/facility'
import facilities from './facility/facilities'
import book from './book/book'
import books from './book/books'
/**
 * STUDENT
 */
import { axiosPlugin } from '@/plugins/axios'
import students from './user/students'
import reservation from './user/reservation'
import abortion from './user/abortion'
import graduation from './graduation'
import studentDashboard from './dashboard/studentDashboard'
import student from './user/student'
import studentImporter from './importer/studentImporter.js'
import sale from '@/store/sale/sale.js'
import transcript from '@/store/transcript/transcript.js'
import _ from 'lodash'
/**
 * DEPARTMENT
 */
import department from './other/department'
import departmentDashboard from '@/store/dashboard/departmentDashboard.js'
import role from './app/role'
import rooms from './department/rooms'
import staff from './user/staff'
import teacher from './user/teacher'
import showcases from './department/showcases'
import teacherDashboard from './dashboard/teacherDashboard'
/**
 * APPLICATIONS
 */
import app from './app/app'
import noti from './notify/noti'
import { createStore } from 'vuex-extensions'
import constant from './other/constant'
import upload from './other/upload'
import rest from './other/rest'
import auth from './app/auth'
import view from './view'
import user from './app/user'
import studentGroup from './user/student-group.js'
import accountant from './user/accountant.js'
import manager from './user/manager.js'
import education_manager from './user/education_manager.js'
import super_admin from './user/super_admin.js'
Vue.use(Vuex)

export default createStore(Vuex.Store, {
  plugins: [
    createPersistedState({
      key: 'lms',
      paths: ['auth.user', 'auth.isAuthenticated', 'auth.jwt']
    }),
    axiosPlugin
  ],
  modules: {
    rest,
    auth,
    view,
    user,
    staff,
    sale,
    teacher,
    class: classModule,
    major,
    majorDetail,
    generation,
    category,
    email,
    constant,
    course,
    lesson,
    resource,
    slot,
    bill,
    leads,
    lead,
    // FACILITY
    facility,
    facilities,
    book,
    books,
    event,
    attendance,
    stats,
    upload,
    noti,
    product,
    app,
    role,
    contact,
    log,
    mark,
    classDetail,
    teacherDashboard,
    departmentDashboard,
    /// //////////// DEPARMENT ///////////////
    rooms,
    department,
    showcases,
    /// //////////// STUDENT ///////////////
    students,
    student,
    studentDashboard,
    studentImporter,
    billDetail,
    transcript,
    marksheet,
    accountsheet,
    accountant,
    manager,
    education_manager,
    super_admin,
    studentGroup,
    reservation,
    abortion,
    graduation
  },
  mixins: {
    mutations: {
      changeState: function (state, changed) {
        Object.entries(changed).forEach(([name, value]) => {
          state[name] = value
        })
      },
      changeDeepState: function (state, changed) {
        Object.entries(changed).forEach(([firstChildName, diff]) => {
          const firstChildValue = { ...state[firstChildName] }
          Object.entries(diff).forEach(([path, diffValue]) => {
            _.setWith(firstChildValue, path, diffValue)
          })
          state[firstChildName] = firstChildValue
        })
      }
    }
  }
})
